import { render, staticRenderFns } from "./FormCRS.vue?vue&type=template&id=250fcea5&scoped=true"
import script from "./FormCRS.vue?vue&type=script&lang=js"
export * from "./FormCRS.vue?vue&type=script&lang=js"
import style0 from "./FormCRS.vue?vue&type=style&index=0&id=250fcea5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250fcea5",
  null
  
)

export default component.exports